module.exports = __webpack_public_path__ + "static/media/hero.292f26b9.jpg";